// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.AssigneePopupSection .MuiDialog-container {
  position: fixed;
  right: 153px;
  bottom: 72px;
  align-items: end;
}
.AssigneePopupSection .assignee-header {
  position: sticky;
  z-index: 1;
  top: 0;
  background: #202437;
}
.AssigneePopupSection .MuiPaper-root {
  max-width: max-content;
  height: 448px;
  background: #202437 !important;
  border-radius: 10px !important;
  border: 1px #28304C !important;
  margin: unset !important;
  overflow-y: unset !important;
}
.AssigneePopupSection span {
  color: rgba(255, 255, 255, 0.4);
  font-family: "Poppins";
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 22px;
}
.AssigneePopupSection .assign-content-wrapper {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 10px 0 10px;
  margin-bottom: 14px;
}
.AssigneePopupSection .assign-content-wrapper .image-wrapper {
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}
.AssigneePopupSection .search-box-wrapper {
  pointer-events: none;
}
.AssigneePopupSection .search-box-wrapper fieldset {
  border-radius: 10px;
  background: rgba(121, 126, 152, 0.08);
  border: unset;
}
.AssigneePopupSection .search-box-wrapper .MuiFormControl-root {
  margin: unset;
  width: 488px;
  padding: 0 10px;
}
.AssigneePopupSection .search-box-wrapper .MuiOutlinedInput-root {
  gap: 5px;
  padding-left: 5px;
  height: 44px;
}
.AssigneePopupSection .search-box-wrapper input {
  color: rgba(255, 255, 255, 0.4);
  font-family: "Poppins";
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 91.523%;
}
.AssigneePopupSection .assignee-list-wrapper {
  margin-top: 8px;
  height: 350px;
  overflow-x: hidden;
}
.AssigneePopupSection .assignee-list-wrapper .assignee-item {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 14px 20px;
  cursor: pointer;
}
.AssigneePopupSection .assignee-list-wrapper .assignee-item:hover {
  background: #28304C;
}
.AssigneePopupSection .assignee-list-wrapper .assignee-item .teleDriverImage img {
  width: 51px;
  height: 51px;
  border-radius: 50%;
}
.AssigneePopupSection .assignee-list-wrapper .assignee-item .assignee-title span {
  font-weight: 600;
  line-height: 140%;
  font-size: 14px;
  color: #fff;
}
.AssigneePopupSection .assignee-list-wrapper .assignee-item .assignee-text {
  display: flex;
  align-items: center;
  gap: 5px;
}
.AssigneePopupSection .assignee-list-wrapper .assignee-item .assignee-text span {
  font-size: 14px;
  color: rgba(255, 255, 255, 0.7);
}
.AssigneePopupSection .assignee-list-wrapper .assignee-item .circle-icon img {
  vertical-align: middle;
}

.scheduledAssigneeSection .MuiDialog-container {
  right: 27.55%;
}`, "",{"version":3,"sources":["webpack://./src/components/common/AssigneePopupSection/styles.scss"],"names":[],"mappings":"AACI;EACI,eAAA;EACA,YAAA;EACA,YAAA;EACA,gBAAA;AAAR;AAEI;EACI,gBAAA;EACA,UAAA;EACA,MAAA;EACA,mBAAA;AAAR;AAEI;EACI,sBAAA;EACA,aAAA;EACA,8BAAA;EACA,8BAAA;EACA,8BAAA;EACA,wBAAA;EACA,4BAAA;AAAR;AAGI;EACI,+BAAA;EACA,sBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;AADR;AAII;EACI,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,yBAAA;EACA,mBAAA;AAFR;AAIQ;EACI,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;AAFZ;AAMI;EACI,oBAAA;AAJR;AAMQ;EACI,mBAAA;EACA,qCAAA;EACA,aAAA;AAJZ;AAOQ;EACI,aAAA;EACA,YAAA;EACA,eAAA;AALZ;AAQQ;EACI,QAAA;EACA,iBAAA;EACA,YAAA;AANZ;AASQ;EACI,+BAAA;EACA,sBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,oBAAA;AAPZ;AAWI;EACI,eAAA;EACA,aAAA;EACA,kBAAA;AATR;AAUQ;EACI,aAAA;EACA,mBAAA;EACA,QAAA;EACA,kBAAA;EACA,eAAA;AARZ;AASY;EACI,mBAAA;AAPhB;AAWgB;EACI,WAAA;EACA,YAAA;EACA,kBAAA;AATpB;AAaY;EACI,gBAAA;EACA,iBAAA;EACA,eAAA;EACA,WAAA;AAXhB;AAcY;EACI,aAAA;EACA,mBAAA;EACA,QAAA;AAZhB;AAcgB;EACI,eAAA;EACA,+BAAA;AAZpB;AAiBgB;EACI,sBAAA;AAfpB;;AAuBI;EACI,aAAA;AApBR","sourcesContent":[".AssigneePopupSection {\n    .MuiDialog-container {\n        position: fixed;\n        right: 153px;\n        bottom: 72px;\n        align-items: end;\n    }\n    .assignee-header{\n        position: sticky;\n        z-index: 1;\n        top: 0;\n        background: #202437;\n    }\n    .MuiPaper-root {\n        max-width: max-content;\n        height: 448px;\n        background: #202437 !important;\n        border-radius: 10px !important;\n        border: 1px #28304C !important;\n        margin: unset !important;\n        overflow-y: unset !important;\n    }\n\n    span {\n        color: rgba(255, 255, 255, 0.40);\n        font-family: 'Poppins';\n        font-size: 12px;\n        font-style: normal;\n        font-weight: 400;\n        line-height: 22px;\n    }\n\n    .assign-content-wrapper {\n        display: flex;\n        justify-content: space-between;\n        align-items: center;\n        padding: 10px 10px 0 10px;\n        margin-bottom: 14px;\n\n        .image-wrapper {\n            width: 24px;\n            height: 24px;\n            display: flex;\n            align-items: center;\n            justify-content: center;\n            cursor: pointer;\n        }\n    }\n\n    .search-box-wrapper {\n        pointer-events: none;\n\n        fieldset {\n            border-radius: 10px;\n            background: rgba(121, 126, 152, 0.08);\n            border: unset;\n        }\n\n        .MuiFormControl-root {\n            margin: unset;\n            width: 488px;\n            padding: 0 10px;\n        }\n\n        .MuiOutlinedInput-root {\n            gap: 5px;\n            padding-left: 5px;\n            height: 44px;\n        }\n\n        input {\n            color: rgba(255, 255, 255, 0.40);\n            font-family: 'Poppins';\n            font-size: 14px;\n            font-style: normal;\n            font-weight: 400;\n            line-height: 91.523%;\n        }\n    }\n\n    .assignee-list-wrapper {\n        margin-top: 8px;\n        height: 350px;\n        overflow-x: hidden;\n        .assignee-item {\n            display: flex;\n            align-items: center;\n            gap: 8px;\n            padding: 14px 20px;\n            cursor: pointer;\n            &:hover {\n                background: #28304C;\n            }\n\n            .teleDriverImage {\n                img {\n                    width: 51px;\n                    height: 51px;\n                    border-radius: 50%;\n                }\n            }\n\n            .assignee-title span {\n                font-weight: 600;\n                line-height: 140%;\n                font-size: 14px;\n                color: #fff;\n            }\n\n            .assignee-text {\n                display: flex;\n                align-items: center;\n                gap: 5px;\n\n                span {\n                    font-size: 14px;\n                    color: rgba(255, 255, 255, 0.70);\n                }\n            }\n\n            .circle-icon {\n                img {\n                    vertical-align: middle;\n                }\n            }\n        }\n    }\n}\n\n.scheduledAssigneeSection {\n    .MuiDialog-container {\n        right: 27.55%;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
